<template>
  <div>
    <div class="mobile-table">
      <div class="order__list" v-for="(order, idx) in orders">
        <div class="order__price">
          {{ order.notifiedPrice.toLocaleString() }}원
        </div>
        <div class="order__pins">
          <div class="order__pin">
            <div class="circle"></div>
            <div>
              <div class="order__name">
                {{ order.pins[0].name }} ({{ order.pins[0].phoneNumber }})
              </div>
              <div class="order__date">
                <orderTag v-if="order.isReserved" status="reserved" />
                {{ $utcToLocal(order.pins[0].pickupTime, "M/D") }} ({{
                  order.pins[0].pickupTime | utcGetDay
                }}) {{ $utcToLocal(order.pins[0].pickupTime, "HH:mm") }} 픽업
                예정
              </div>
            </div>
          </div>
          <div class="order__pin">
            <div class="circle circle__full"></div>
            <div>
              <div class="order__name">
                {{ order.pins[order.pins.length - 1].name }} ({{
                  order.pins[order.pins.length - 1].phoneNumber
                }})
              </div>
              <div class="order__date">
                <orderTag v-if="order.isExpressDelivery" status="express" />
                {{
                  $utcToLocal(
                    order.pins[order.pins.length - 1].pickupTime,
                    "M/D"
                  )
                }}
                ({{ order.pins[order.pins.length - 1].pickupTime | utcGetDay }})
                {{
                  $utcToLocal(
                    order.pins[order.pins.length - 1].pickupTime,
                    "HH:mm"
                  )
                }}
                이내 도착 예정
              </div>
            </div>
          </div>
        </div>
        <div class="order__option">
          <div class="order__option--list">
            <div>배송수단</div>
            <div class="order__transportation">
              {{
                filterVehicleCategory(
                  vehicles,
                  order.vehicle.vehicleCategoryCode
                )
              }}
            </div>
          </div>
          <div class="order__option--list">
            <div>배송물품</div>
            <div class="order__item">
              <div>{{ mergeItem(order.item) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import orderTag from "@/components/common/orderTag.vue";
import mixinFilter from "@/mixins/mixinFilter";
import mixinVehicle from "@/mixins/mixinVehicle";
export default {
  mixins: [mixinFilter, mixinVehicle],
  props: ["orders", "vehicles"],
  components: {
    orderTag,
  },
  methods: {
    mergeItem(item) {
      let count = 0;
      let result = "";

      for (const key in item) {
        const value = item[key];
        if (key !== "weight" && key !== "fragile") {
          if (key === "etc" && value !== null && value !== "") {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)}`;
          }
          if (key !== "etc" && value > 0) {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)} ${item[key]}개`;
          }
        }
      }

      return result;
    },
  },
};
</script>
<style src="./layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
